import { useEffect, useState } from 'react';

import { fetchEmotes } from './api';

const REFRESH_MS = 5 * 60 * 1000; // the admin may drop a new file during the event

// The custom emotes of the chat: an empty list until they load, and if they never do
const useEmotes = () => {
  const [emotes, setEmotes] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = () =>
      fetchEmotes()
        .then((list) => {
          if (alive) setEmotes(list);
        })
        .catch(() => {}); // the chat works without emotes
    load();
    const interval = setInterval(load, REFRESH_MS);
    return () => {
      alive = false;
      clearInterval(interval);
    };
  }, []);

  return emotes;
};

export default useEmotes;
